import store from '@/app/store/store';

export default {
  path: '/on-board',
  name: 'on-board',
  component: () => import(/* webpackChunkName: "on-board" */ '@/app/views/onboard/OnBoard.vue'),
  beforeEnter: (to, from, next) => {
    if (from.name === 'auth') {
      next();
    } else if (!store.getters['account/getAccount']) {
      next();
    } else {
      next('/');
    }
  },
  meta: {
    requiresAuth: true,
  },
};
